<template>
  <div>

    <div class="space-sm"></div>

    <div class="container-full">

      <div class="grid-12">
        <div class="grid-12 padding-sm box">
          <form @submit.stop.prevent="getResponses">
            <div class="grid-3 padding-sm">
              <label class="form-label">Franquia</label>
              <select class="form-field" v-model="franchise">
                <option v-for="franchise in franchises" :value="franchise['slug']" v-bind:key="franchise['slug']">{{franchise['nome']}}</option>
              </select>
            </div>
            <div class="grid-3 padding-sm">
              <label class="form-label">Data Inicial</label>
              <input type="date" class="form-field" v-model="dateStart">
            </div>
            <div class="grid-3 padding-sm">
              <label class="form-label">Data Final</label>
              <input type="date" class="form-field" v-model="dateEnd">
            </div>
            <div class="break"></div>
            <div class="grid-3 padding-sm">
              <button class="button button-full">Buscar</button>
            </div>
            <div class="grid-3 padding-sm" v-if="!loading.excel">
              <!-- <button @click="downloadExcel" type="button" class="button button-full">Download Excel</button> -->
            </div>
            <div class="grid-3" v-if="loading.excel">
              <i class="fas fa-spinner fa-spin"></i> Gerando Excel...
            </div>
          </form>
        </div>
      </div>

      <div class="grid-12">
        <div class="grid-12 no-padding box">

          <div class="grid-12" v-if="loading.responses">
            <i class="fas fa-spinner fa-spin"></i> Carregando respostas...
          </div>

          <div class="grid-12" v-if="!loading.responses">
            <table class="table">
              <thead>
                <tr>
                  <td>NOME</td>
                  <td>TELEFONE</td>
                  <td>CURSO</td>
                  <td>1 - O QUE O SR(A) ESPERA DESSE CURSO?</td>
                  <td>2- POR QUAL MEIO DE COMUNICAÇÃO O SR(A) FICOU SABENDO DA ESCOLA VIA CERTA?</td>
                  <td>3- POR QUAL MOTIVO O SR(A) ESCOLHEU A VIA CERTA PARA FAZER O CURSO?</td>
                  <td>4 - ESTÁ SATISFEITO COM O CONTEÚDO DAS AULAS?</td>
                  <td>SE NÃO: PORQUE?</td>
                  <td>5 - DE 1 A 10 QUAL NOTA DARIA PARA O VIA CERTA?</td>
                  <td>6 - MOTIVO DA NOTA:</td>
                  <td>7 - QUAL O NOME DO SEU EDUCADOR?</td>
                  <td>8 - ESTÁ SATISFEITO COM O ATENDIMENTO PRESTADO POR ELE DENTRO DA SALA DE AULA?</td>
                  <td>SE NÃO: PORQUE?</td>
                  <td>9 - DE 1 A 10 QUAL NOTA DARIA PARA SEU EDUCADOR?</td>
                  <td>10 - O SR(A) GOSTARIA DE INDICAR ALGUÉM DE SUA FAMÍLIA OU AMIGOS PARA FAZER UM CURSO CONOSCO? QUE ESTEJA PRECISANDO DE UM EMPREGO OU ATUALIZAÇÃO PROFISSIONAL?</td>
                  <td>11 - VOCÊ TEM ALGUMA SUGESTÃO DE MELHORIA PARA A UNIDADE ONDE ESTUDA?</td>
                  <td>DATA</td>
                </tr>
              </thead>
              <tbody>
                <tr v-for="response in responses" v-bind:key="response.name">
                  <td>{{response.nome}}</td>
                  <td>{{response.telefone}}</td>
                  <td>{{response.curso}}</td>
                  <td>{{response.pergunta1}}</td>
                  <td>{{response.pergunta2}}</td>
                  <td>{{response.pergunta3}}</td>
                  <td>{{response.pergunta4}}</td>
                  <td>{{response.pergunta4obs}}</td>
                  <td>{{response.pergunta5}}</td>
                  <td>{{response.pergunta6}}</td>
                  <td>{{response.pergunta7}}</td>
                  <td>{{response.pergunta8}}</td>
                  <td>{{response.pergunta8obs}}</td>
                  <td>{{response.pergunta9}}</td>
                  <td>{{response.pergunta10}}</td>
                  <td>{{response.pergunta11}}</td>
                  <td>{{response.data}}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

      </div>
    </div>

  </div>
</template>

<script>
  import axios from 'axios';

  export default {
    name: 'files',
    data() {
      return {
        dateStart: null,
        dateEnd: null,
        franchise: null,
        franchises: [],
        responses: null,
        loading: {
          responses: false,
          excel: false
        }
      }
    },
    methods: {
      getResponses() {
        this.loading.responses = true;
        var self = this;
        var data = new FormData();
        if (this.dateStart) {
          data.append('dateStart', this.dateStart);
        } 
        if (this.dateEnd) {
          data.append('dateEnd', this.dateEnd);
        }
        data.append('franchise', this.franchise);
        data.append('auth_code',  this.$store.state.login.auth_code);
        axios
          .post(process.env.VUE_APP_API + "/get_responses.php", data)
          .then(function (response) {
            self.loading.responses = false;
            self.responses = response.data.responses;
          })
          .catch(function (error) {
            self.loading.responses = false;
          });
      },
      getFranchises() {
        var self = this;
        var data = new FormData();
        data.append('auth_code',  this.$store.state.login.auth_code);
        axios
          .post(process.env.VUE_APP_API + "/get_franchises.php", data)
          .then(function (response) {
            console.log(response.data.franchises);
            self.franchises = response.data.franchises;
          })
      },
      downloadExcel(){
        this.loading.excel = true;
        var self = this;
        var data = new FormData();
        if (this.dateStart) {
          data.append('dateStart', this.dateStart);
        } 
        if (this.dateEnd) {
          data.append('dateEnd', this.dateEnd);
        }
        data.append('franchise', this.franchise);
        data.append('auth_code',  this.$store.state.login.auth_code);
        axios
        .post(process.env.VUE_APP_API + "/excel_responses.php", data)
        .then(response => {
          const url = window.URL.createObjectURL(new Blob([response.data]))
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', 'responses.xls')
          document.body.appendChild(link)
          link.click()
          self.loading.excel = false;
        })
      }
    },
    mounted() {
      this.getFranchises();
    },
    watch: {
      $route() {
        this.getFranchises();
      }
    }
  }
</script>